module.exports = __webpack_public_path__ + "img/share-bg-22.6d86ff72.jpg";